import React, { useEffect, useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import _ from "lodash";
import buildQuery from 'odata-query'
import { getUserFactoryId } from '../../../index';
import api from '../../services/api';



export function SelectAsyncPaginateUsers({ apiurl = 'user', preload = true, filterFactory = true, onChangeCallback, value = null }) {

    const [selected, setSelected] = useState({
        id: 0,
        name: '',
        sap: ''
    })

    useEffect(() => {
        setSelected({
            id: 0,
            name: '',
            sap: ''
        })
    }, []);

    const loadOptions = async (searchQuery, loadedOptions, { page }) => {

        let filter = {
            status: true
        }

        if (filterFactory) {
            filter = _.merge(filter, {
                'factoryId': { eq: parseInt(getUserFactoryId()) },
            })
        }

        if (searchQuery.length > 0) {
            filter = _.merge(filter, {
                name: {
                    contains: searchQuery
                }
            })
        }

        const response = await fetchDataByOdata(
            {
                filter,
                top: 10,
                skip: (page - 1) * 10,
                select: ['name', 'id', 'sap'],
                orderBy: ['Name asc'],
                count: true
            })

        if (response.status !== 200) {
            console.log(response.error);
            return
        }

        return {
            options: response.data.value,
            hasMore: response.data._count > page * 10,
            additional: {
                page: page + 1,
            },
        };
    };

    function fetchDataByOdata(odata) {
        return api.get(`${apiurl}/odata${buildQuery(odata)}`)
    }

    const onChange = (option) => {
        if (typeof onChangeCallback === "function") {
            option = {
                ...option,
                apiurl: apiurl
            }
            onChangeCallback(option);
        }
        setSelected(option);
    };

    return (
        <>
            {preload ?
                <AsyncPaginate
                    defaultOptions
                    key={JSON.stringify(apiurl)}
                    value={selected.id != 0 ? selected : (value == null ? (selected || "") : value)}
                    loadOptions={loadOptions}
                    getOptionValue={(option) => option.name}
                    getOptionLabel={(option) => option.name == '' ? '' : option.name + ' ('+ option.sap+ ')'}
                    onChange={onChange}
                    isSearchable={true}
                    placeholder=""
                    debounceTimeout={500}
                    additional={{
                        page: 1,
                    }}
                />
                :
                <AsyncPaginate
                    key={JSON.stringify(apiurl)}
                    value={selected.id != 0 ? selected : (value == null ? (selected || "") : value)}
                    loadOptions={loadOptions}
                    getOptionValue={(option) => option.name}
                    getOptionLabel={(option) => option.name}
                    onChange={onChange}
                    isSearchable={true}
                    placeholder=""
                    debounceTimeout={500}
                    additional={{
                        page: 1,
                    }}
                />
            }
        </>
    );
};
